import OrganizationWebhookSelector from "../../components/WebhookConfig/Webhookconfig";

const WebhookConfig = () => {
    return <OrganizationWebhookSelector />;
};
export default WebhookConfig;